import React, { useEffect } from "react";
import Card from "../Components/CardStucher";
import FormRenderer from "Common/Custom/FormRenderer";
import DeleteButton from "./DeleteButton";
import { validateAdvanceRow } from "../HELPERS/Helpers"


const AdvanceDetailsList = ({
  Advance_Details,
  paymentMethodTypesOption,
  values,
  setValues,
  setErrors,
  errors,
  emptyPaymentDetail,
  validateField,
  AdvanceDetailsRules,
  FillAutoAdvanceAmount = false
}) => {
  const rows = values.PaymentDetail || [];
  const baseFields = Advance_Details?.filter((e) => e.name !== "remaining_amount");

  // A row is "locked" (already saved against a booking) if it has a non-empty booking_id
  const isRowLocked = (row) =>
    row?.booking_id !== undefined &&
    row?.booking_id !== null &&
    row?.booking_id !== "";

  

  const handleAdd = () => {
    setValues((prev) => ({
      ...prev,
      PaymentDetail: [
        ...prev.PaymentDetail,
        { ...emptyPaymentDetail, Unic_key: crypto.randomUUID() },
      ],
    }));
  };

  const handleRemove = (index) => {
    setValues((prev) => {
      // Guard: never remove a locked (already booked) row
      if (isRowLocked(prev.PaymentDetail[index])) return prev;
      return {
        ...prev,
        PaymentDetail: prev.PaymentDetail.filter((_, i) => i !== index),
      };
    });
  };

  

  const handleRowChange = (index) => (eOrName, value) => {
  if (isRowLocked(rows[index])) return;

  let fieldName, fieldValue;
  if (typeof eOrName === "object" && eOrName?.target) {
    fieldName = eOrName.target.name;
    fieldValue = eOrName.target.value;
  } else {
    fieldName = eOrName;
    fieldValue = value;
  }

  let updatedRow;

  setValues((prev) => {
    const updatedRows = [...prev.PaymentDetail];
    updatedRow = { ...updatedRows[index], [fieldName]: fieldValue };
    updatedRows[index] = updatedRow;
    return { ...prev, PaymentDetail: updatedRows };
  });

  setErrors((prev) => {
    const paymentErrors = [...(prev.PaymentDetail || [])];

    // existing per-field rule (e.g. maxLength, float, minNumber)
    const ruleErrorMsg = AdvanceDetailsRules[fieldName]
      ? validateField(fieldName, fieldValue, AdvanceDetailsRules)
      : undefined;

    // cross-field "required if sibling filled" check
    const crossFieldErrors = validateAdvanceRow(updatedRow,paymentMethodTypesOption);

    paymentErrors[index] = {
      ...(paymentErrors[index] || {}),
      payment_method: crossFieldErrors.payment_method,
      transaction_id: crossFieldErrors.transaction_id,
      advance_amount: crossFieldErrors.advance_amount,
      // let a real rule error (maxLength etc.) override the generic "required" message
      [fieldName]: ruleErrorMsg || crossFieldErrors[fieldName],
    };

    return { ...prev, PaymentDetail: paymentErrors };
  });
};

  useEffect(() => {
    if (!FillAutoAdvanceAmount) return;

    setValues((prev) => {
      if (!prev.PaymentDetail?.length) return prev;

      const PaymentDetail = [...prev.PaymentDetail];
      PaymentDetail[0] = {
        ...PaymentDetail[0],
        advance_amount: String(prev.total_amount || ""),
      };

      return {
        ...prev,
        PaymentDetail,
      };
    });
  }, [FillAutoAdvanceAmount, values.total_amount]);

  return (
    <Card
      CardHeaderClass="card-header"
      CardRowClass="row g-3"
      isRow={false}
      heading={<h6 className="card-title">Advance Details</h6>}
    >
      {rows.map((rowValues, index) => {
        const locked = isRowLocked(rowValues);

        const fields = baseFields?.map((field) => ({
          ...field,
          disabled: locked,
        }));

        const isErr = Object.values(errors?.PaymentDetail?.[index] || {}).some(
          (value) => !!value
        );


        return (
          <div
            className={`row g-2  mb-2 ${isErr ? "align-items-start" : "align-items-end"}`}
            key={rowValues.Unic_key || index}
          >

            <FormRenderer
              fields={fields}
              values={rowValues}
              errors={errors?.PaymentDetail?.[index] || {}}
              handleChange={handleRowChange(index)}
              optionConfig={{
                payment_method: {
                  list: paymentMethodTypesOption,
                  valueKey: "payment_method_id",
                  labelKey: "payment_method_name",
                },
              }}
              isrow={false}
            />

            <div className="col-lg-2 col-md-2 col-3 d-flex align-items-start mt-4 pt-2 gap-1">
              {index === rows.length - 1 && (
                <button
                  type="button"
                  onClick={handleAdd}
                  className="btn btn-sm btn-primary py-2 mt-1"
                  title="Add Payment Detail"
                  aria-label="Add Payment Detail"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M12 5l0 14" />
                    <path d="M5 12l14 0" />
                  </svg>
                </button>
              )}

              {rows.length > 1 && !locked && (
                <DeleteButton disabled={false} onClick={() => handleRemove(index)} />
              )}
            </div>
          </div>
        );
      })}
    </Card>
  );
};

export default AdvanceDetailsList;